// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"378":"site","975":"site-blog"}[chunkId] + "." + {"378":"2ff2ec0d","975":"2ff2ec0d"}[chunkId] + ".chunk.css";
};